/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

export const setIsCreatingInbox = createAction('inboxes/setIsCreatingInbox');

export const reducer = (builder) => {
  builder.addCase(
    setIsCreatingInbox.type,
    (state, { payload }) => {
      state.isCreatingInbox = payload;
    },
  );
};
